<ng-template #directDepositDisclaimerModal let-modal>
  <div class="modal-header justify-content-between">
    <h4 class="modal-title d-inline-block fw-bold">Authorization Required</h4>
    <br />
    <button type="button" class="close ms-3" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      By checking the box below, I am electronically signing and authorizing this change. I
      understand that my checkmark represents my signature and signifies my agreement to the terms
      and conditions contained here. I authorize ConnectPay, LLC, my employer and the financial
      institution(s) listed to deposit my pay automatically to the indicated account(s) as directed.
      I agree to review my payroll statement immediately each pay period and notify my employer of
      any incorrect payments. As an employee of this Company, I understand that if I receive funds
      that do not belong to me, I authorize my employer, ConnectPay and my bank to make adjusting
      entries as required. If funds are not available at the time, I authorize ConnectPay and my
      employer to set-off the net of future paychecks and/or any and all tax withholdings in the
      amount of the adjustments required. I, the undersigned, understand it is my responsibility to
      verify deposits are posted before attempting to use these funds. I also understand and agree
      that neither my employer nor ConnectPay is responsible for bank errors and fees, should I make
      payments against funds that have not yet been made collectible by my bank. I may cancel my
      Direct Deposit(s) at any time.
    </p>
  </div>
  <div class="modal-footer justify-content-between">
    <lib-checkbox label="Authorize" [(ngModel)]="authorized"></lib-checkbox>
    <button class="btn btn-primary" (click)="submitModal()" [disabled]="!authorized">Submit</button>
  </div>
</ng-template>
